// Module
var code = "<div id=\"V-12E3E9FB-8817-4BC2-A0BC-5CC0270E0A1F\"> <div data-b-component=\"checkbox\" data-b-comp-checked=\"{Binding value}\"></div> </div> ";
// Exports
export default code;